'use client';

import { useI18n } from '@fshr/context/i18n-context';
import BevSafeText from '../bev-safe-text';

type BookingDetailFieldProps = {
	label: string;
	value: string;
	required?: boolean;
};

export function BookingDetailField({ label, value, required = true }: BookingDetailFieldProps) {
	return (
		<div className="flex min-w-0 flex-col gap-[2px]">
			<span className="text-label text-text-secondary">
				<BevSafeText>{label}</BevSafeText>
				{required ? '*' : ''}
			</span>
			<span className="break-words h-[47px] text-body2 text-text-primary">{value || '—'}</span>
		</div>
	);
}

type BookingFoundDetailsProps = {
	property: string;
	lastName: string;
	checkInDate: string;
	checkOutDate: string;
};

export function BookingFoundDetails({
	property,
	lastName,
	checkInDate,
	checkOutDate,
}: BookingFoundDetailsProps) {
	const { t } = useI18n();

	return (
		<div className="grid w-full grid-cols-1 gap-[10px] md:grid-cols-2 md:gap-x-[30px] md:gap-y-[6px]">
			<BookingDetailField label={t('Property')} value={property} />
			<BookingDetailField label={t('Last Name')} value={lastName} />
			<BookingDetailField label={t('Check In Date')} value={checkInDate} />
			<BookingDetailField label={t('Check Out Date')} value={checkOutDate} />
		</div>
	);
}
